import { Link } from 'react-router-dom'
import * as Tooltip from '@radix-ui/react-tooltip'

import { Body } from '@foxino/components-web'
import { GraduationHat01 } from '@foxino/icons-react'

import { RouteType } from '@app/config/router/navMenu.types'
import resolveTailwindClasses from '@app/utils/resolveTailwindClasses'

type Props = RouteType & {
  isActive: boolean
  isExpanded: boolean
  iconClassName?: string
  className?: string
}

export const NavigationItem = ({
  id,
  to,
  Icon = GraduationHat01,
  isActive,
  isExpanded,
  label,
  testId,
  disabled,
  className,
  iconClassName,
  iconPosition = 'left'
}: Props) => {
  return (
    <Link
      id={id}
      to={disabled ? '#' : to}
      data-testid={testId}
      className={resolveTailwindClasses(
        'relative flex w-full cursor-pointer items-center justify-center gap-3 overflow-hidden rounded-md text-sm text-primary-200 transition-colors hover:cursor-pointer hover:bg-primary-600',
        isActive && 'rounded-lg !bg-primary-400 shadow-sm',
        iconPosition === 'right' ? 'flex-row-reverse justify-between' : 'justify-left',
        className
      )}
    >
      <Tooltip.Provider>
        <Tooltip.Root delayDuration={0}>
          {isExpanded ? (
            <Icon className={resolveTailwindClasses('m-3', iconClassName)} />
          ) : (
            <Tooltip.Trigger>
              <Icon className={resolveTailwindClasses('m-2', iconClassName)} />
            </Tooltip.Trigger>
          )}

          <Tooltip.Portal>
            <Tooltip.Content
              sideOffset={15}
              side="right"
              className="z-50 rounded-lg bg-white px-[10px] py-2 text-black shadow-2xl ring-1 ring-primary-200"
            >
              <Body size="md" weight={isActive ? 'bold' : 'regular'}>
                {label}
              </Body>
              <Tooltip.Arrow className="fill-white" />
            </Tooltip.Content>
          </Tooltip.Portal>

          {isExpanded && (
            <Body size="md" className="text-primary-200" weight={isActive ? 'bold' : 'regular'}>
              {label}
            </Body>
          )}
        </Tooltip.Root>
      </Tooltip.Provider>

      {isActive && <div className="absolute -right-2 top-1/2 h-[10px] w-3 -translate-y-1/2 rounded-sm bg-white" />}
    </Link>
  )
}
